export const ADMIN_STATUSES = {
  unverified: { label: "Unverified", tone: "bg-slate-100 text-slate-700 dark:bg-slate-500/15 dark:text-slate-300" },
  trial: { label: "Trial", tone: "bg-sky-50 text-sky-700 dark:bg-sky-500/15 dark:text-sky-300" },
  trial_expired: { label: "Trial expired", tone: "bg-orange-50 text-orange-700 dark:bg-orange-500/15 dark:text-orange-300" },
  active: { label: "Active", tone: "bg-emerald-50 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-300" },
  past_due: { label: "Past due", tone: "bg-amber-50 text-amber-800 dark:bg-amber-500/15 dark:text-amber-300" },
  canceled: { label: "Canceled", tone: "bg-red-50 text-red-700 dark:bg-red-500/15 dark:text-red-300" },
  comped: { label: "Free (comped)", tone: "bg-violet-50 text-violet-700 dark:bg-violet-500/15 dark:text-violet-300" },
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" }) : "—");

export const StatusBadge = ({ status, suspended }) => (
  <span className="inline-flex flex-wrap gap-1" data-testid="admin-status-badge">
    <span className={`rounded-md px-2 py-0.5 text-xs font-medium ${ADMIN_STATUSES[status]?.tone || ADMIN_STATUSES.unverified.tone}`}>
      {ADMIN_STATUSES[status]?.label || status}
    </span>
    {suspended && <span className="rounded-md bg-red-600 px-2 py-0.5 text-xs font-medium text-white">Suspended</span>}
  </span>
);
